module.exports = __webpack_public_path__ + "media/images/soar/soar-cf6ca0c4c9f64b8ad5e470e66bd80d85.svg";